export default{
    section:'بخش',
    medicalAbbreviationTestsTitle: 'عنوان',
    sectionStatus: 'وضعیت',
    medicalAbbreviationTests:'MedicalAbbreviationTests',
    editMedicalAbbreviationTests:'ویرایش MedicalAbbreviationTests',
    addMedicalAbbreviationTests:'MedicalAbbreviationTests جدید',
}